module.exports = __webpack_public_path__ + "img/iconfont.d456eb31.svg";